import * as AppUtils from '../../utils';
import * as ApiModel from '../model';

// tslint:disable:no-any
export function isErrorResponse(responseJson: any): responseJson is ApiModel.ApiErrorResponse {
  const expectedKeys: Array<keyof ApiModel.ApiErrorResponse> = ['HttpCode', 'Message', 'Errors'];
  const hasExpectedKeys = AppUtils.objectHasOwnKeys(responseJson, expectedKeys);
  return hasExpectedKeys && Array.isArray(responseJson.Errors);
}

export function responseContainsIneligibilityError(responseJson: any): boolean {
  return isErrorResponse(responseJson) && responseJson.Errors.some((e) => e.Code === 30086);
}

export async function extractApiErrorMessageFromResponse(response: any, defaultErrorMessage?: string) {
  if (!AppUtils.isObject(response)) {
    return Promise.resolve(defaultErrorMessage || '');
  }

  let responseJson: any = response;
  let httpStatusCode: number | undefined;
  let errorMessage = '';
  try {
    if (response instanceof Response) {
      httpStatusCode = response.status;
      responseJson = await AppUtils.tryGetResponseJson(response);
    }

    if (isErrorResponse(responseJson)) {
      errorMessage = responseJson.Message;
      if (responseJson.Errors.length > 0 && responseJson.Errors[0].Message.length > 0) {
        errorMessage = responseJson.Errors[0].Message;
      }
    } else if (AppUtils.objectHasOwnKeys(responseJson, ['Message']) && AppUtils.isString(responseJson.Message)) {
      errorMessage = responseJson.Message;
    }

    errorMessage = errorMessage.trim();
  } catch (e) {
    if (process.env.REACT_APP_ENV !== 'production') {
      console.log(`ERROR: ApiUtils::extractApiErrorMessageFromResponse: ${e}`);
    }
  }

  if (errorMessage.length === 0) {
    errorMessage = defaultErrorMessage || '';
  }

  return httpStatusCode ? `(HTTP ${httpStatusCode}) ${errorMessage}` : errorMessage;
}

export function isVerifyActivationTokenApiSuccessResponse(obj: any): obj is ApiModel.VerifyActivationTokenApiSuccessResponse {
  const expectedKeys: Array<keyof ApiModel.VerifyActivationTokenApiSuccessResponse> = ['activated'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}

export function isSubmitEnrollmentApiSuccessResponse(obj: any): obj is ApiModel.SubmitEnrollmentApiSuccessResponse {
  const expectedKeys: Array<keyof ApiModel.SubmitEnrollmentApiSuccessResponse> = ['RegNumber', 'RetVal', 'Msg'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}

export function isConfirmEnrollmentApiSuccessResponse(obj: any): obj is ApiModel.ConfirmEnrollmentApiSuccessResponse {
  const expectedKeys: Array<keyof ApiModel.ConfirmEnrollmentApiSuccessResponse> = ['regNo', 'eid', 'returncode'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}

export function isApiErrorLogExtraData(obj: any): obj is ApiModel.ApiErrorLogExtraData {
  const expectedKeys: Array<keyof ApiModel.ApiErrorLogExtraData> = ['Request Url'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}

export function isVerifyActivationTokenApiErrorLogExtraData(obj: any): obj is ApiModel.VerifyActivationTokenApiErrorLogExtraData {
  const expectedKeys: Array<keyof ApiModel.VerifyActivationTokenApiErrorLogExtraData> = ['Request Url', 'Activation Token'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}

export function isSubmitEnrollmentApiErrorLogExtraData(obj: any): obj is ApiModel.SubmitEnrollmentApiErrorLogExtraData {
  const expectedKeys: Array<keyof ApiModel.SubmitEnrollmentApiErrorLogExtraData> = ['Request Url', 'Activation Token'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}

export function isConfirmEnrollmentApiErrorLogExtraData(obj: any): obj is ApiModel.ConfirmEnrollmentApiErrorLogExtraData {
  const expectedKeys: Array<keyof ApiModel.ConfirmEnrollmentApiErrorLogExtraData> = ['Request Url', 'Regno', 'IntxErrorCode'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}

export function isIntxGotoWebApiErrorLogExtraData(obj: any): obj is ApiModel.IntxGotoWebApiErrorLogExtraData {
  const expectedKeys: Array<keyof ApiModel.IntxGotoWebApiErrorLogExtraData> = ['Request Url', 'Regno', 'IntxUniqueId'];
  return AppUtils.objectHasOwnKeys(obj, expectedKeys);
}
// tslint:enable:no-any
